import { render, staticRenderFns } from "./WorkshopViewModal.vue?vue&type=template&id=00dcbed9&scoped=true&"
import script from "./WorkshopViewModal.vue?vue&type=script&lang=js&"
export * from "./WorkshopViewModal.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopViewModal.vue?vue&type=style&index=0&id=00dcbed9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dcbed9",
  null
  
)

export default component.exports